import React from 'react';
import Footer from 'gatsby-theme-carbon/src/components/Footer';
import env from '../../../env';

const currentYear = new Date().getFullYear();
const lastUpdated = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
}).format(new Date());

const ContentInternal = () => (
  <>
    <p>
      Have questions? Email us or open an issue in{' '}
      <a href="https://github.ibm.com/maximo/manage-unittest-documentation">GitHub</a>
      .
      <br />
      <br />
      Last updated {lastUpdated}
      <br />
      Copyright © {currentYear} IBM
    </p>
  </>
);

const ContentPublic = () => (
  <>
    <p>
      Last updated {lastUpdated}
      <br />
      Copyright © {currentYear} IBM
    </p>
  </>
);

const linksInternal = {
  firstCol: [
    { href: 'https://www.ibm.com/privacy', linkText: 'Privacy' },
    { href: 'https://www.ibm.com/legal', linkText: 'Terms of Use' },
    { href: 'https://www.ibm.com/', linkText: 'IBM.com' },
  ],
  secondCol: [
    {
      href: 'https://github.ibm.com/maximo/manage-unittest-documentation',
      linkText: 'Contribute',
    }
  ],
};

const linksPublic = {
  firstCol: [
    { href: 'https://www.ibm.com/privacy', linkText: 'Privacy' },
    { href: 'https://www.ibm.com/legal', linkText: 'Terms of Use' },
    { href: 'https://www.ibm.com/', linkText: 'IBM.com' },
  ]
};

let links = (env.internalOnly ? linksInternal : linksPublic);
let Content = (env.internalOnly ? ContentInternal : ContentPublic);

const CustomFooter = (props) => (
  <Footer {...props} links={links} Content={Content} />
);

export default CustomFooter;
